import './Loading.css'

interface LoadingProps {
    variant?: 'spinner' | 'dots'
    size?: 'small' | 'medium' | 'large'
    text?: string
    style?: React.CSSProperties
}

const Loading = ({ variant = 'spinner', size = 'medium', text, style }: LoadingProps) => {
    return (
        <div className={`loading loading_${size}`} style={style}>
            {variant === 'spinner' ? (
                <div className={`loading_spinner loading_spinner_${size}`}></div>
            ) : (
                <div className="loading_dots">
                    <div className="loading_dot"></div>
                    <div className="loading_dot"></div>
                    <div className="loading_dot"></div>
                </div>
            )}
            {text && <div className="loading_text">{text}</div>}
        </div>
    )
}

export default Loading


